import { MutableValue } from "../api/mutable-value.interface";

export default class HolidayPeriod implements MutableValue {
  public isNew = false;

  private fCreatedAt?: Date;
  private fUpdatedAt?: Date;

  constructor(private fId: string, private fName: string) {
    [fId, fName].forEach((arg, index) => {
      if (arg === undefined) {
        throw new Error(`Undefined value passed at position: ${index}`);
      }
    });
  }

  get id(): string {
    return this.fId;
  }

  get name(): string {
    return this.fName;
  }

  get createdAt(): Date | undefined {
    return this.fCreatedAt;
  }

  get updatedAt(): Date | undefined {
    return this.fUpdatedAt;
  }
}
